import React from 'react';
import { LoginPage } from './LoginPage';
import { useAuth } from './AuthContext';

export function AuthGate(props: { children: React.ReactNode }) {
  const { children } = props;
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f7fbf4',
          color: '#2c352d',
          fontSize: '14px',
        }}
      >
        Checking session...
      </div>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  return <>{children}</>;
}
